/**
 * AppSkeleton - Loading placeholder for App Shell
 * Shows a skeleton that matches the AppShell layout structure (sidebar + header + content)
 */
export function AppSkeleton() {
  return (
    <div className="flex h-screen w-screen overflow-hidden bg-background animate-pulse">
      {/* Sidebar Skeleton */}
      <div className="hidden md:flex flex-col w-64 border-r border-gray-200 dark:border-gray-800 bg-gray-50 dark:bg-gray-900">
        {/* Sidebar Header */}
        <div className="h-14 px-4 flex items-center border-b border-gray-200 dark:border-gray-800">
          <div className="h-8 w-8 bg-gray-200 dark:bg-gray-700 rounded" />
          <div className="h-5 w-24 bg-gray-200 dark:bg-gray-700 rounded ml-3" />
        </div>
        
        {/* Sidebar Navigation */}
        <div className="flex-1 p-4 space-y-2">
          {[...Array(6)].map((_, i) => (
            <div key={i} className="flex items-center space-x-3 p-2">
              <div className="h-5 w-5 bg-gray-200 dark:bg-gray-700 rounded" />
              <div className="h-4 w-28 bg-gray-200 dark:bg-gray-700 rounded" />
            </div>
          ))}
        </div>
        
        {/* Sidebar Footer */}
        <div className="p-4 border-t border-gray-200 dark:border-gray-800">
          <div className="flex items-center space-x-3">
            <div className="h-8 w-8 bg-gray-200 dark:bg-gray-700 rounded-full" />
            <div className="h-4 w-20 bg-gray-200 dark:bg-gray-700 rounded" />
          </div>
        </div>
      </div>

      {/* Main Content Area */}
      <div className="flex flex-col flex-1 min-w-0">
        {/* Header Skeleton */}
        <header className="h-14 px-4 flex items-center justify-between border-b border-gray-200 dark:border-gray-800">
          <div className="flex items-center space-x-4">
            <div className="md:hidden h-8 w-8 bg-gray-200 dark:bg-gray-700 rounded" />
            <div className="h-5 w-32 bg-gray-200 dark:bg-gray-700 rounded" />
          </div>
          <div className="flex items-center space-x-3">
            <div className="h-8 w-48 bg-gray-200 dark:bg-gray-700 rounded" />
            <div className="h-8 w-8 bg-gray-200 dark:bg-gray-700 rounded" />
          </div>
        </header>

        {/* Content Skeleton */}
        <main className="flex-1 overflow-auto p-6">
          <div className="max-w-4xl space-y-6">
            {/* Page Title */}
            <div className="h-8 w-64 bg-gray-200 dark:bg-gray-700 rounded" />
            
            {/* Content Cards */}
            <div className="grid md:grid-cols-2 gap-6">
              {[...Array(4)].map((_, i) => (
                <div key={i} className="p-6 bg-gray-100 dark:bg-gray-800 rounded-lg">
                  <div className="h-6 w-3/4 bg-gray-200 dark:bg-gray-700 rounded mb-3" />
                  <div className="h-4 w-full bg-gray-200 dark:bg-gray-700 rounded mb-2" />
                  <div className="h-4 w-2/3 bg-gray-200 dark:bg-gray-700 rounded" />
                </div>
              ))}
            </div>
          </div>
        </main>

        {/* Footer Skeleton */}
        <footer className="h-10 px-4 flex items-center justify-between border-t border-gray-200 dark:border-gray-800">
          <div className="h-3 w-24 bg-gray-200 dark:bg-gray-700 rounded" />
          <div className="h-3 w-32 bg-gray-200 dark:bg-gray-700 rounded" />
        </footer>
      </div>
    </div>
  );
}
